import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { CatalogoProtocolo } from '../../model/catalogo.model';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CatalogoSvgApiService extends BaseApiService {

  getCatalogoProtocolo(codProtocolo: number, usuario: string): Observable<CatalogoProtocolo> {
    return this.invocarSeguros<CatalogoProtocolo>('GET', `catalogo/svg/protocolo/${codProtocolo}/${usuario}`);
  }

  getCatalogoColectiva(codColectiva: string): Observable<CatalogoProtocolo> {
    return this.invocarSeguros<CatalogoProtocolo>('GET', `catalogo/svg/protocolo/${codColectiva}`);
  }

  esEnvioEpigrafes(codprotocolo: string): Observable<boolean> {
    return this.invocarSeguros<boolean>('GET', `catalogo/svg/epigrafes/${codprotocolo}`);
  }

  getProtocolosDisponibles(cia: number,ramo: number,moda: number,submoda: number,nombreAgente: string): Observable<CatalogoProtocolo[]> {
    const requestBody = {
      cia: cia,
      ramo: ramo,
      moda: moda,
      submoda: submoda,
      usuario: nombreAgente
    };
    return this.invocarSeguros<CatalogoProtocolo[]>('POST', `catalogo/protocolos-producto`, requestBody);
  }
}
